module.exports = __webpack_public_path__ + "static/media/attach.0cac860c.png";